/* eslint-disable no-shadow */
import { Typography } from '@material-ui/core';
import { FC } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import style from './style';

interface IItemAddRestitution {
  variableIndex: string | number;
  position: number;
}

const ItemAddRestitution: FC<IItemAddRestitution> = ({ variableIndex, position }) => {
  const classes = style();
  const history = useHistory();
  const location = useLocation();

  const handleClick = () => {
    // Déterminer si on est en mode "edit" basé sur le path actuel
    const isEditMode = location.pathname.includes('/edit');

    // Sauvegarder la position où insérer la nouvelle page
    sessionStorage.setItem('addRestitutionPagePosition', position.toString());

    // Rediriger vers ModelVariable pour choisir le modèle
    const basePath = isEditMode
      ? `/admin/game/model-variable/${variableIndex}/edit`
      : `/admin/game/model-variable/${variableIndex}`;

    history.push(`${basePath}?mode=addPage`);
  };

  return (
    <div className={classes.container} onClick={handleClick}>
      <Typography variant="h4" className={classes.title}>
        +
      </Typography>
    </div>
  );
};

export default ItemAddRestitution;

